import { render, staticRenderFns } from "./ArgInputContactList.vue?vue&type=template&id=237d86f9&scoped=true"
import script from "./ArgInputContactList.vue?vue&type=script&lang=ts"
export * from "./ArgInputContactList.vue?vue&type=script&lang=ts"
import style0 from "./ArgInputContactList.vue?vue&type=style&index=0&id=237d86f9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237d86f9",
  null
  
)

export default component.exports